import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';

const Reviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const reviews = [
    {
      text: "For only £4.50 we got fries, burger, drink and chicken wings. Ready in less than 10 minutes even during peak hours. Incredible value.",
      author: "Sarah M.",
      role: "Regular Customer",
      rating: 5
    },
    {
      text: "This place is amazing. Best food in the area and the staff are so kind. The doner wrap is absolutely delicious!",
      author: "James T.",
      role: "Local Guide",
      rating: 5
    },
    {
      text: "Hidden gem in Chapel Market! Generous portions, authentic flavors, and the owner always greets you with a smile.",
      author: "Priya K.",
      role: "Food Enthusiast",
      rating: 4
    },
    {
      text: "Been coming here for years. Consistently good quality, fair prices, and quick service. My go-to spot for lunch.",
      author: "Michael R.",
      role: "Local Resident",
      rating: 5
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [reviews.length]);

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <section className="py-20 bg-zinc-900 relative overflow-hidden">
      {/* Decorative gradient */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-orange-600/10 to-red-600/10 rounded-full blur-3xl" />
      
      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What People <span className="text-orange-500">Are Saying</span>
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6" />
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="flex">
              {[...Array(4)].map((_, i) => (
                <span key={i} className="text-yellow-400 text-3xl">★</span>
              ))}
              <span className="text-gray-600 text-3xl">★</span>
            </div>
            <span className="text-white font-semibold text-xl ml-2">4.0 / 5</span>
          </div>
          <p className="text-gray-400">Based on 231 reviews</p>
        </div>

        <div className="relative">
          {/* Review Card */}
          <div className="bg-zinc-800/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-zinc-700 shadow-2xl">
            <Quote className="h-12 w-12 text-orange-500 mb-6 opacity-50" />
            
            <div className="min-h-[200px] flex flex-col justify-center">
              {reviews.map((review, index) => (
                <div
                  key={index}
                  className={`transition-opacity duration-500 ${
                    index === currentIndex ? 'opacity-100' : 'opacity-0 absolute'
                  }`}
                >
                  <p className="text-xl md:text-2xl text-gray-200 leading-relaxed mb-8 italic">
                    "{review.text}"
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-white font-bold text-lg">{review.author}</p>
                      <p className="text-gray-400">{review.role}</p>
                    </div>
                    
                    <div className="flex">
                      {[...Array(review.rating)].map((_, i) => (
                        <span key={i} className="text-yellow-400 text-xl">★</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <Button
              variant="outline"
              size="icon"
              onClick={prevReview}
              className="bg-zinc-800 border-zinc-700 hover:bg-orange-500 hover:border-orange-500 text-white rounded-full w-12 h-12 transition-all duration-300"
            >
              <ChevronLeft className="h-5 w-5" />
            </Button>
            
            <div className="flex gap-2">
              {reviews.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentIndex 
                      ? 'bg-orange-500 w-8' 
                      : 'bg-zinc-700 hover:bg-zinc-600'
                  }`}
                />
              ))}
            </div>
            
            <Button
              variant="outline"
              size="icon"
              onClick={nextReview}
              className="bg-zinc-800 border-zinc-700 hover:bg-orange-500 hover:border-orange-500 text-white rounded-full w-12 h-12 transition-all duration-300"
            >
              <ChevronRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
